'use client';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useRouter } from 'next/navigation';
import { LuCookie } from 'react-icons/lu';

export function CookieConsentFab() {
  const router = useRouter();
  const { t } = useTranslations();

  const handleClick = () => {
    // Preserve the shared consent event contract and the older query fallback.
    const eventDetail = { handled: false };
    window.dispatchEvent(
      new CustomEvent('eliadmin:open-cookie-preferences', { detail: eventDetail }),
    );
    if (eventDetail.handled) return;

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('occ', 'true');
    router.push(`${window.location.pathname}?${searchParams.toString()}${window.location.hash}`);
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      variant="none"
      size="icon"
      className="ea-cookie-consent-fab fixed bottom-16 left-4 z-[1000] !w-10 !bg-transparent text-foreground !shadow-none hover:!bg-transparent sm:bottom-8"
      aria-label={t('text267')}
    >
      <LuCookie size={24} aria-hidden="true" />
    </Button>
  );
}
